import { lazy } from "react";

export const Bonus = lazy(() =>
  import("./bonus").then((module) => ({
    default: module.Bonus,
  })),
);

export const Documents = lazy(() =>
  import("./documents").then((module) => ({
    default: module.Documents,
  })),
);

export const Home = lazy(() =>
  import("./home").then((module) => ({
    default: module.Home,
  })),
);

export const VacationPage = lazy(() =>
  import("./vacation").then((module) => ({
    default: module.VacationPage,
  })),
);

export const InvitationPage = lazy(() =>
  import("./invitation").then((module) => ({
    default: module.InvitationPage,
  })),
);

export const TimesheetPage = lazy(() =>
  import("./timesheet").then((module) => ({
    default: module.TimesheetPage,
  })),
);

export const ProfilePage = lazy(() =>
  import("./profile").then((module) => ({
    default: module.ProfilePage,
  })),
);

export const DocumentHubPage = lazy(() =>
  import("./document-hub").then((module) => ({
    default: module.DocumentHubPage,
  })),
);

export const KnowledgeBasePage = lazy(() =>
  import("./knowledge-base").then((module) => ({
    default: module.KnowledgeBasePage,
  })),
);

export const AssistantPage = lazy(() =>
  import("./assistant").then((module) => ({
    default: module.AssistantPage,
  })),
);

export const PeoplePage = lazy(() =>
  import("./people").then((module) => ({
    default: module.PeoplePage,
  })),
);

export const PeopleProfilePage = lazy(() =>
  import("./people-profile").then((module) => ({
    default: module.PeopleProfilePage,
  })),
);
